import { Component, HostListener, OnInit, ViewChild } from "@angular/core";
import { MatTabGroup } from "@angular/material/tabs";
import { DomSanitizer } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";
import { Location } from "@angular/common";
import { Router } from "@angular/router";
import { firstValueFrom } from "rxjs";
import { s3Url } from "src/app/shared";
import { VodService } from "src/app/shared/services/vod.service";
import { Vod, VodListCategory, VodCategory } from "../../../shared/models/vod";
import "vidstack/player";
import "vidstack/player/ui";
import "vidstack/icons";

@Component({
  selector: "app-vod",
  templateUrl: "./tbox-vod.component.html",
  styleUrls: ["./tbox-vod.component.css", "./player.css"]
})
export class TboxVodComponent implements OnInit {
  @HostListener("window:beforeunload", ["$event"])
  beforeUnloadHandler(event) {
    document.querySelectorAll("#myVideo").forEach(videoItem => {
      const video = <HTMLVideoElement>videoItem;
      video.pause();
      video.setAttribute("src", "");
    });

    document.querySelectorAll("#themVod").forEach(videoItem => {
      const video = <HTMLVideoElement>videoItem;
      video.pause();
      video.setAttribute("src", "");
    });

    this.addVodView();
  }
  @ViewChild("tabs", { static: false })
  tabGroup: MatTabGroup;
  constructor(private vodService: VodService, public route: ActivatedRoute, private sanitizer: DomSanitizer, private location: Location, public router: Router) {}

  vodCategoryList: VodCategory[];
  vodListCategory: VodListCategory;
  selectedVod: Vod = {
    id: 0,
    title: "",
    category_id: 0,
    content: "",
    content_vod: "",
    preview: "",
    thumbnail: "",
    level: 0,
    gangsa: "",
    vod_min: 0,
    favorite: false,
    save_time: 0
  };

  playSource: any = "";
  isString = false;
  loading = true;
  loadingFirst = true;
  open = false;
  continue = false;
  userView = false;

  canPlayEvent = false;

  page = 1;
  pageSize = 9;

  totalPlayTime = 0;
  startTime: number;

  async ngOnInit() {
    this.vodCategoryList = await firstValueFrom(this.vodService.getVodCategoryList(2));

    if (this.route.snapshot.paramMap.get("vodId") == undefined) {
      this.vodListCategory = await firstValueFrom(this.vodService.getVodListCategory(this.vodCategoryList[0].id));
    } else {
      const vodId = Number(this.route.snapshot.paramMap.get("vodId"));

      if (JSON.parse(localStorage.getItem("profile")) == undefined) {
        this.selectedVod = await firstValueFrom(this.vodService.getVodData(vodId));
      } else {
        this.selectedVod = await firstValueFrom(this.vodService.getVodData(vodId, +JSON.parse(localStorage.getItem("profile")).id));
      }

      this.selectedVod.thumbnail = s3Url + this.selectedVod.thumbnail;

      this.tabGroup.selectedIndex = this.vodCategoryList.findIndex(data => data.id == this.selectedVod.category_id);

      this.vodListCategory = await firstValueFrom(this.vodService.getVodListCategory(this.selectedVod.category_id));

      this.initVod();

      this.open = true;
    }

    this.vodListCategory.vod_list.forEach(data => {
      data.thumbnail = s3Url + data.thumbnail;
    });

    this.loading = false;
  }

  public async changeSelectedCategory(e) {
    if (this.loadingFirst) {
      this.loadingFirst = false;
    } else {
      this.open = false;
      this.loading = true;

      document.querySelectorAll("#myVideo").forEach(videoItem => {
        const video = <HTMLVideoElement>videoItem;
        video.pause();
        video.setAttribute("src", "");
      });

      document.querySelectorAll("#themVod").forEach(videoItem => {
        const video = <HTMLVideoElement>videoItem;
        video.pause();
        video.setAttribute("src", "");
      });

      const categoryId = this.vodCategoryList[e.index].id;

      this.vodListCategory = await firstValueFrom(this.vodService.getVodListCategory(categoryId));

      this.vodListCategory.vod_list.forEach(data => {
        data.thumbnail = s3Url + data.thumbnail;
      });

      this.loading = false;
    }
  }

  public async changeSelectedContent(e) {
    this.open = false;

    document.querySelectorAll("#myVideo").forEach(videoItem => {
      const video = <HTMLVideoElement>videoItem;
      video.pause();
      video.setAttribute("src", "");
    });

    if (JSON.parse(localStorage.getItem("profile")) == undefined) {
      this.selectedVod = await firstValueFrom(this.vodService.getVodData(e.id));
    } else {
      this.selectedVod = await firstValueFrom(this.vodService.getVodData(e.id, +JSON.parse(localStorage.getItem("profile")).id));
    }

    this.selectedVod.thumbnail = s3Url + this.selectedVod.thumbnail;

    this.location.go("kr/tbox-vod/" + this.selectedVod.id);

    this.initVod();
    this.open = true;
  }

  initVod() {
    this.totalPlayTime = 0;

    if (this.selectedVod.content_vod.length) {
      this.playSource = this.selectedVod.content_vod;
      this.userView = true;
    } else {
      this.playSource = this.selectedVod.preview;
    }

    if (this.playSource.indexOf("youtube") > -1) {
      this.isString = true;
      this.playSource = this.sanitizer.bypassSecurityTrustHtml(
        `<iframe width="100%" height="388px" src="` + this.playSource + `" frameborder="0" allow="accelerometer; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>`
      );
    } else {
      this.isString = false;
    }
  }

  ended() {
    this.addVodView();
    if (this.continue) {
      let vodIndex = this.vodListCategory.vod_list.findIndex(data => (data.id = this.selectedVod.id));
      this.changeSelectedContent(this.vodListCategory.vod_list[vodIndex + 1].id);
    }
  }

  toggleFavorite(vodId: number, mark: boolean) {
    if (!localStorage.getItem("token")) {
      alert("로그인이 필요합니다");
    } else {
      if (mark) {
        this.vodService.removeVodFavorite(+JSON.parse(localStorage.getItem("profile"))?.id, +vodId).subscribe({
          complete: () => {
            this.selectedVod.favorite = false;
          }
        });
      } else {
        this.vodService.addVodFavorite(+JSON.parse(localStorage.getItem("profile"))?.id, +vodId).subscribe({
          complete: () => {
            this.selectedVod.favorite = true;
          }
        });
      }
    }
  }

  pauseEvent() {
    let finishTime = Date.now();
    this.totalPlayTime += Number((finishTime - this.startTime) / 1000);
  }
  playEvent() {
    this.startTime = Date.now();
  }
  addVodView() {
    if (this.userView) {
      let video = <HTMLVideoElement>document.getElementById("myVideo");
      this.pauseEvent();
      if (JSON.parse(localStorage.getItem("profile")) != undefined && this.totalPlayTime > 0) {
        this.vodService.addVodView(+JSON.parse(localStorage.getItem("profile"))?.id, this.selectedVod.id, video.currentTime);
        this.vodService.addVodViewLog(+JSON.parse(localStorage.getItem("profile"))?.id, this.selectedVod.id, this.totalPlayTime);
      }
    }
  }
}

// 썸네일 눌렀을 때 스크롤 탑
$(document).ready(function () {
  $(document).on("click", ".thumbnail_box", function () {
    $("html, body").animate({
      scrollTop: 0
    });
  });
});
